<div class="modal" [class.is-active]="isVisible">
  <div class="modal-background"></div>
  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onConfirmClick()" autocomplete="off">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ title }}</p>
        </header>
        <section class="modal-card-body">
          <div formArrayName="formFields">
            @for (field of fields; track field; let i = $index) {
              <div class="field">
                <label [for]="field.inputLabel" class="label">{{
                  field.inputLabel
                }}</label>
                @if (field.inputType === "dropdown") {
                  <select
                    class="select is-fullwidth"
                    #modalInput
                    [formControlName]="i"
                    [id]="field.inputLabel"
                    (change)="customErrors[field.inputLabel] = []"
                    [class.is-danger]="
                      formSubmitted &&
                      (formControls[i].errors ||
                        customErrors[field.inputLabel].length > 0)
                    "
                    [attr.tabindex]="i + 1"
                  >
                    @if (!field.disableHumanize) {
                      @for (option of field.dropDownOptions; track option) {
                        <option [value]="option">
                          {{ option | humanize }}
                        </option>
                      }
                    } @else {
                      @for (option of field.dropDownOptions; track option) {
                        <option [value]="option">
                          {{ option }}
                        </option>
                      }
                    }
                  </select>
                }
                @if (field.inputType === "boolean") {
                  <input
                    [id]="field.inputLabel"
                    #modalInput
                    type="checkbox"
                    class="switch is-primary"
                    [formControlName]="i"
                    (change)="customErrors[field.inputLabel] = []"
                    [class.is-danger]="
                      formSubmitted &&
                      (formControls[i].errors ||
                        customErrors[field.inputLabel].length > 0)
                    "
                    [attr.tabindex]="i + 1"
                  />
                  <label class="label" [for]="field.inputLabel"></label>
                }
                @if (field.inputType === "textarea") {
                  <textarea
                    class="textarea"
                    [placeholder]="field.placeholder"
                    [id]="field.inputLabel"
                    #modalInput
                    [formControlName]="i"
                    (change)="customErrors[field.inputLabel] = []"
                    [attr.tabindex]="i + 1"
                  ></textarea>
                }
                @if (field.inputType === "file") {
                  <input
                    [id]="field.inputLabel"
                    #modalInput
                    type="file"
                    class="input"
                    [formControlName]="i"
                    (change)="handleFileSelection($event, i)"
                    [class.is-danger]="
                      formSubmitted &&
                      (formControls[i].errors ||
                        customErrors[field.inputLabel].length > 0)
                    "
                    [attr.tabindex]="i + 1"
                    [accept]="field.accept"
                  />
                  <label class="label" [for]="field.inputLabel"></label>
                }
                @if (
                  field.inputType === "text" || field.inputType === "email"
                ) {
                  <input
                    [placeholder]="field.placeholder"
                    [id]="field.inputLabel"
                    #modalInput
                    class="input"
                    [type]="field.inputType"
                    [formControlName]="i"
                    [pattern]="field.pattern"
                    (keydown)="customErrors[field.inputLabel] = []"
                    [class.is-danger]="
                      formSubmitted &&
                      (formControls[i].errors ||
                        customErrors[field.inputLabel].length > 0)
                    "
                    [attr.tabindex]="i + 1"
                  />
                }
                @if (field.inputType === "float") {
                  <input
                    [placeholder]="field.placeholder"
                    [id]="field.inputLabel"
                    #modalInput
                    class="hide-number-input-arrows"
                    type="number"
                    inputmode="decimal"
                    step="0.0000000001"
                    [formControlName]="i"
                    (change)="customErrors[field.inputLabel] = []"
                    (keydown)="restrictInvalidCharacters($event)"
                    [class.is-danger]="
                      formSubmitted &&
                      (formControls[i].errors ||
                        customErrors[field.inputLabel].length > 0)
                    "
                    [attr.tabindex]="i + 1"
                  />
                }
                @if (field.inputType === "ng-select") {
                  <ng-select
                    #modalInput
                    [formControlName]="i"
                    [id]="field.inputLabel"
                    [items]="field.ngSelectConfigs.options"
                    [bindLabel]="field.ngSelectConfigs.bindLabel"
                    [bindValue]="field.ngSelectConfigs.bindValue"
                    [placeholder]="
                      field.placeholder ? field.placeholder : 'Select an option'
                    "
                    appendTo="body"
                    [multiple]="false"
                    [closeOnSelect]="true"
                    [clearable]="false"
                    (change)="customErrors[field.inputLabel] = []"
                    [searchable]="false"
                    [class.is-danger]="
                      formSubmitted &&
                      (formControls[i].errors ||
                        customErrors[field.inputLabel].length > 0)
                    "
                    [attr.tabindex]="i + 1"
                  >
                    <!-- Customizes the look of each item in the dropdown if a template was provided -->
                    @if (field.ngSelectConfigs.optionsTemplate) {
                      <ng-template ng-option-tmp let-item="item">
                        <ng-container
                          *ngTemplateOutlet="
                            field.ngSelectConfigs.optionsTemplate;
                            context: { $implicit: item }
                          "
                        />
                      </ng-template>
                    }
                    <!-- Customizes the look of the selected item if a template was provided -->
                    @if (field.ngSelectConfigs.labelTemplate) {
                      <ng-template ng-label-tmp let-item="item">
                        <ng-container
                          *ngTemplateOutlet="
                            field.ngSelectConfigs.labelTemplate;
                            context: { $implicit: item }
                          "
                        />
                      </ng-template>
                    }
                  </ng-select>
                }
                @if (field.inputType === "infoMessage") {
                  <div
                    class="flex items-center gap-2 rounded-lg bg-steel-blue-50/30 p-3 text-steel-blue-500"
                  >
                    <svg-icon
                      src="/assets/icons/general/info.svg"
                      class="shrink-0"
                    />
                    <span> {{ field.message }}</span>
                  </div>
                }
                @if (field.inputType === "bannerMessage") {
                  <div
                    class="flex items-center gap-2 rounded-lg bg-steel-blue-50/30 p-3 text-steel-blue-500"
                  >
                    <span> {{ field.message }}</span>
                  </div>
                }
                @if (formSubmitted && formControls[i].errors) {
                  <div class="text-sm text-red-600">
                    @if (formControls[i].errors.required) {
                      <p>{{ field.inputLabel }} is required</p>
                    }
                    @if (formControls[i].errors.email) {
                      <p>Please enter a valid email address</p>
                    }
                    @if (formControls[i].errors.minlength) {
                      <p>
                        {{ field.inputLabel }} cannot be shorter than
                        {{ field.minLength }}
                        characters
                      </p>
                    }
                    @if (formControls[i].errors.maxlength) {
                      <p>
                        {{ field.inputLabel }} cannot be longer than
                        {{ field.maxLength }}
                        characters
                      </p>
                    }
                    @if (formControls[i].errors.min) {
                      <p>
                        {{ field.inputLabel }} cannot be smaller than
                        {{ field.min }}
                      </p>
                    }
                    @if (formControls[i].errors.max) {
                      <p>
                        {{ field.inputLabel }} cannot be larger than
                        {{ field.max }}
                      </p>
                    }
                    @if (formControls[i].errors.pattern) {
                      <p>
                        {{ patternValidationMessage }}
                      </p>
                    }
                    <!-- Add new validation here -->
                  </div>
                }
                <!-- Custom errors-->
                @if (customErrors[field.inputLabel].length > 0) {
                  <div class="text-sm text-red-600">
                    @for (
                      error of customErrors[field.inputLabel];
                      track error
                    ) {
                      <p>
                        {{ error }}
                      </p>
                    }
                  </div>
                }
                <!--End custom errors-->
              </div>
            }
          </div>
        </section>
        <footer class="modal-card-foot">
          <button
            class="button is-link"
            type="submit"
            [class]="confirmBtnClass"
            [class.is-loading]="isLoading"
            [disabled]="!(form.dirty || formDirty)"
            [attr.tabindex]="fields.length + 1"
          >
            {{ confirmBtnText }}
          </button>
          <button
            class="button"
            (click)="onCancelClick()"
            type="button"
            [class.is-disabled]="isLoading"
            [attr.tabindex]="fields.length + 2"
          >
            Cancel
          </button>
        </footer>
      </div>
    </form>
  }
</div>
